(function () {
  'use strict';
  var data = window.MEGA_COLLECTIONS_PREVIEW || {};
  var PANEL_CLASS = 'mega-menu__collection-preview-inline';
  var ACTIVE_CLASS = 'has-mega-collection-preview';
  function isDesktop() { return window.matchMedia('(min-width:990px)').matches; }
  function extractHandle(href) {
    if (!href) return null;
    var m = href.match(/\/(collections|pages|products)\/([^/?#]+)/);
    if (!m) return null;
    var h = m[2];
    if (h === 'all' || h === 'vendors' || h === 'types') return null;
    return h;
  }
  function getCollection(handle) {
    return data[handle] || null;
  }
  function findContainer(link) {
    var menu = link.closest('.mega-menu__content, .mega-menu, header-menu, details');
    if (!menu) return null;
    var existing = menu.querySelector('.mega-menu__image-row');
    if (existing) return existing;
    var layout = menu.querySelector('.mega-menu__layout');
    if (!layout) layout = menu.querySelector('.mega-menu__container');
    if (!layout) layout = menu.querySelector('.mega-menu__content');
    if (!layout) return null;
    layout.classList.add('mega-menu__layout--with-image');
    var imageArea = document.createElement('div');
    imageArea.className = 'mega-menu__image mega-menu__image--dynamic';
    var row = document.createElement('div');
    row.className = 'mega-menu__image-row';
    var ghost = document.createElement('div');
    ghost.className = 'mega-menu__image-wrapper';
    row.appendChild(ghost);
    imageArea.appendChild(row);
    layout.appendChild(imageArea);
    return row;
  }
  function ensurePreview(container) {
    var wrappers = container.querySelectorAll('.mega-menu__image-wrapper');
    if (wrappers.length === 0) return null;
    var host = wrappers[0];
    if (!host.dataset.originalContent) {
      host.dataset.originalContent = host.innerHTML;
    }
    host.classList.add('mega-preview-host');
    for (var i = 1; i < wrappers.length; i++) {
      wrappers[i].classList.add('mega-preview-hidden');
    }
    host.innerHTML = '<div class="mega-preview-content"><a class="mega-preview__link"><div class="mega-preview__media"><img alt="" loading="lazy"></div><div class="mega-preview__text"><p class="mega-preview__eyebrow"></p><h3 class="mega-preview__title"></h3><p class="mega-preview__description"></p><span class="mega-preview__cta"></span></div></a></div>';
    return host;
  }
  function getEyebrow(type) {
    var loc = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
    if (type === 'product') {
      return ({ en: 'Gift idea', it: 'Idea regalo', de: 'Geschenkidee', ja: 'ギフトのご提案' })[loc] || 'Idea regalo';
    }
    if (type === 'page') {
      return ({ en: 'Page', it: 'Pagina', de: 'Seite', ja: 'ページ' })[loc] || 'Pagina';
    }
    return ({ en: 'Collection', it: 'Collezione', de: 'Kollektion', ja: 'コレクション' })[loc] || 'Collezione';
  }
  function getCta() {
    var loc = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
    return ({ en: 'Explore', it: 'Esplora', de: 'Entdecken', ja: '探索' })[loc] || 'Esplora';
  }
  function render(preview, col) {
    if (!preview || !col) { return; }
    var link = preview.querySelector('.mega-preview__link');
    var img = preview.querySelector('img');
    var eyebrow = preview.querySelector('.mega-preview__eyebrow');
    var titleEl = preview.querySelector('.mega-preview__title');
    var descEl = preview.querySelector('.mega-preview__description');
    var ctaEl = preview.querySelector('.mega-preview__cta');
    if (!link || !img || !titleEl) return;
    link.href = col.url || '#';
    if (col.image) {
      img.src = col.image;
      img.alt = col.title || '';
    } else {
      img.removeAttribute('src');
    }
    if (eyebrow) eyebrow.textContent = getEyebrow(col.type);
    titleEl.textContent = col.title || '';
    var desc = (col.description || '').trim();
    if (desc.length > 200) desc = desc.substring(0, 197) + '...';  // 200 dal 19/10/2026: testo card Gift Card IT di 195 caratteri
    if (descEl) descEl.textContent = desc;
    if (ctaEl) ctaEl.textContent = getCta();
  }
  function activatePreview(container, link) {
    container.classList.add(ACTIVE_CLASS);
    var preview = ensurePreview(container);
    var h = extractHandle(link.getAttribute('href'));
    if (!h) return;
    var col = getCollection(h);
    render(preview, col);
  }
  function deactivatePreview(container) {
    if (!container) return;
    container.classList.remove(ACTIVE_CLASS);
    var imageArea = container.closest('.mega-menu__image--dynamic');
    if (imageArea) {
      imageArea.remove();
      return;
    }
    var wrappers = container.querySelectorAll('.mega-menu__image-wrapper');
    wrappers.forEach(function (w) {
      w.classList.remove('mega-preview-host', 'mega-preview-hidden');
      if (w.dataset.originalContent) {
        w.innerHTML = w.dataset.originalContent;
        delete w.dataset.originalContent;
      }
    });
  }
  function deactivateAll() {
    document.querySelectorAll('.has-mega-collection-preview').forEach(deactivatePreview);
  }
  function onHover(link) {
    if (!isDesktop()) return;
    var container = findContainer(link);
    if (!container) return;
    activatePreview(container, link);
  }
  function init() {
    document.querySelectorAll('.mega-menu__link, .header__menu-item, .header__submenu a').forEach(function (link) {
      if (link.tagName !== 'A') return;
      if (!extractHandle(link.getAttribute('href'))) return;
      link.addEventListener('mouseenter', function () { onHover(link); });
      link.addEventListener('focus', function () { onHover(link); });
    });
    document.querySelectorAll('.mega-menu__content, header-menu, details.mega-menu').forEach(function (c) {
      c.addEventListener('mouseleave', function () {
        var containers = c.querySelectorAll('.has-mega-collection-preview');
        containers.forEach(deactivatePreview);
      });
    });
    document.querySelectorAll('details.mega-menu, header-menu details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) {
          var containers = d.querySelectorAll('.has-mega-collection-preview');
          containers.forEach(deactivatePreview);
        }
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
